import{Trigger as o}from'../../external/@radix-ui/react-tooltip/dist/index.module.js';const t=o;export{t as TooltipTrigger};
